import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';

import { environment } from '@environments/environment';

import { UtilitiyService } from './utility.service';

import { UploadedFiles } from '@classes/wiki/uploaded-files.model';
import { HtmlFile } from '@classes/wiki/html-file.model';
import { RenameFileOrDir } from '@classes/wiki/rename-file-or-dir.model';
import { FileModel } from '@classes/wiki/file-model.model';
import { ProviderType } from '@enums/provider-type.enum';

@Injectable({
  providedIn: 'root'
})
export class EditorService {


  private editMode = new BehaviorSubject<boolean>(false);

  constructor(private httpClient: HttpClient, private utilityService: UtilitiyService) {
    const editable = sessionStorage.getItem(environment.editable);
    if (editable) {
      const bool = editable === 'true';
      this.editMode.next(bool);
    }
   }

  uploadFile(file: UploadedFiles, provider: string = null): Observable<any> {
    return this.httpClient.post<any>(`${environment.apiUrl}wiki/files/html${provider === null ? '' : `?provider=${provider}`}`, file);
  }

  printFile(path: string, provider: ProviderType = null): Observable<any> {
    const encrypted = this.utilityService.encryptString(path);
    return this.httpClient.get<any>(`${environment.apiUrl}wiki/files/${encrypted}/pdf${provider === null ? '' : `?provider=${provider}`}`, {responseType: 'blob' as 'json'});
  }

  getFile(filePath: string, language: string, provider: string = null): Observable<HtmlFile> {
    const encrypted = this.utilityService.encryptString(filePath);
    return this.httpClient.get<HtmlFile>(`${environment.apiUrl}wiki/files/${encrypted}/content?language=${language}${provider === null ? '' : `&provider=${provider}`}`);
  }

  changeName(renameFile: RenameFileOrDir): Observable<FileModel> {
    return this.httpClient.put<FileModel>(`${environment.apiUrl}wiki/files`, renameFile);
  }

  getEditMode(): Observable<boolean> {
    return this.editMode.asObservable();
  }

  changeEditMode(mode: boolean): void {
    this.editMode.next(mode);
  }
}
